<template>
  <modal
    :title="
      'Match Hotel Name (' +
        setModel.ProviderHotelName +
        ' - ' +
        setModel.HotelName +
        ')'
    "
    :size="'md'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="hotels == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        v-if="hotels != null"
        class="floating-labels p-1rem row"
        ref="form"
      >
        <div class="col-md-12">
          <selectBox
            :title="'HotelId'"
            :as="'select'"
            :disabled="hotels.length == 0"
            v-model="model.HotelId"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #search>
              <input
                type="text"
                placeholder="Ara"
                class="form-control small"
                v-model="searchHotels"
              />
            </template>
            <template #input>
              <option :value="null"></option>
              <template v-for="item in hotels">
                <option
                  :value="item.Id"
                  v-if="
                    item.Name.toUpperCase().indexOf(
                      searchHotels.toUpperCase()
                    ) > -1
                  "
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
            </template>
          </selectBox>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="hotels == null"
        :process="process"
        >{{ "Match Hotel Name" }}</Btn
      >
    </template>
  </modal>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
export default {
  props: {
    setModel: Object,
    operators: Array,
  },
  components: { selectBox },
  data() {
    return {
      model: {
        Id: this.setModel.Id,
        HotelId: null,
      },
      searchHotels: "",
      process: false,
      hotels: null,
    };
  },
  watch: {
    // selectCountry(){
    //     this.model.CountryId=this.selectCountry.Id;
    //     this.model.Code1=this.selectCountry.ISO2;
    //     this.model.Code2=this.selectCountry.ISO3;
    //     this.model.Code3=this.selectCountry.CurrencyCode;
    // }
  },
  created() {
    this.$appAxiosAdmin.get(`CustomerHotels`).then((response) => {
      this.hotels = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`KOLAYREZ/ProviderHotelNames/Match`, this.model)
            .then(() => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Hotel name successfully matched",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit("match", {
                ...this.setModel,
                HotelId: this.model.HotelId,
                HotelName: this.hotels.filter((x) => {
                  return x.Id == this.model.HotelId;
                })[0].Name,
              });
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$swal({
                icon: "error",
                title: "Error",
                text: err.response.data.title,
                timer: 2000,
                confirmButtonText: "Okey",
              });
            });
        }
      });
    },
  },
};
</script>

<style></style>
